import { Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { MainContent } from "./MainContent/MainContent";
import { SiderData } from "./SiderData/SiderData";
import { Features } from "./Features/Features";
import { EnvironmentalConsciousnessPageHeading } from "./EnvironmentalConsciousnessPageHeading";


export const EnvironmentalConsciousness = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
 
  const items = [
    {
      label: "Main Content",
      key: "MainContent",
      children: <MainContent/>
    },
    {
      label: "Sider Data",
      key: "SiderData",
      children: <SiderData/>
    },
    {
      label: "Features",
      key: "Features",
      children: <Features/>
    },
    {
      label:"Page Heading",
      key: "environmentalConsciousnessPageHeading",
      children: <EnvironmentalConsciousnessPageHeading/>
    }
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${activeKey}`);
        }}
      ></Tabs>
    </>
  );
};
